/* eslint-disable */
export default {
  unknown: 'Sconosciuto',
  anonymous: 'Numero anonimo',
  activeCalls: 'Tutte le chiamate',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
